<template>
  <div>
    <div class="w3-modal" :class="{'show': modal === 1}">
      <div class="w3-modal-content w3-small">
        <div class="top-bar primary header-fixed">
          <button class="w3-button" style="margin: 6px" @click="atualizarProduto(false)">
            Cancelar
          </button>
          <button class="w3-button w3-right" style="margin: 6px" @click="atualizarProduto(true)">
            Concluir
            <i class="fa fa-edit"></i>
          </button>
        </div>
        <div class="w3-row container-header-fixed">
            <div style="padding: 35px 16px 42px">

                <div v-show="dados.produto.id_medida === '2'">
                    <label><b>Quantidade</b></label>
                    <money v-bind="kilo" class="w3-input w3-border" v-model="dados.quantidade"/>
                </div>

                <div class="w3-margin-bottom" v-show="dados.produto.id_medida === '1'">
                    <label><b>Quantidade</b></label>
                    <div class="w3-cell-row w3-border">
                        <div class="w3-cel">
                            <div style="font-weight: bold; padding: 6px">{{dados.quantidade | fixed}}</div>
                        </div>
                        <div class="w3-cell" style="width:15%">
                            <button class="w3-button primary w3-block" @click="minusQtd()">
                                <i class="fa fa-minus"></i>
                            </button>
                        </div>
                        <div class="w3-cell" style="width:15%">
                            <button class="w3-button primary w3-block w3-border-left w3-border-white" @click="plusQtd()">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <label><b>Dados</b></label>
                <div class="w3-border ">
                    <div class="w3-cell-row w3-padding w3-border-bottom">
                        <div class="w3-cell" style="width: 60px">
                            <b>Item:</b>
                        </div>
                        <div class="w3-cell">
                            {{dados.produto.nome_produto}}
                            <b v-show="dados.produto.principal !== '1'"> - {{dados.produto.nome_tabela}}</b>
                        </div>
                    </div>
                    <div class="w3-cell-row w3-padding w3-border-bottom">
                        <div class="w3-cell" style="width: 60px">
                            <b>QTD:</b>
                        </div>
                        <div class="w3-cell">
                            {{dados.quantidade | fixed}}
                        </div>
                    </div>
                    <div class="w3-cell-row w3-padding w3-border-bottom">
                        <div class="w3-cell" style="width: 60px">
                            <b>Total:</b>
                        </div>
                        <div class="w3-cell">
                            R$ {{(dados.quantidade * dados.produto.valor) | valor}}
                        </div>
                    </div>
                    <div class="w3-cell-row w3-padding">
                        <div class="w3-cell" style="width: 60px">
                            <b>Obs:</b>
                        </div>
                        <div class="w3-cell">
                            {{dados.produto.observacao}}
                            &nbsp;
                        </div>
                    </div>
                </div>
                <div style="height: 45px; margin-top: 4px">
                    <button class="w3-button primary w3-right w3-round w3-block w3-margin-top" @click="() => {modalConfirm= true, modal= false}"><i class="fa fa-trash-o"></i> <b>Deletar Produto</b></button>
                </div>
            </div>
        </div>
      </div>
    </div>

      <!--modal confirm-->
      <div class="w3-modal modal-msg" :class="{'show':modalConfirm}">
          <div class="w3-modal-content w3-center w3-round w3-padding-16" style="min-height: inherit">
              <div style="padding: 20px 20px;color: #353535">
                  <b id="confirm-text" class="w3-large">Deseja remover o produto?</b><br>
              </div>
              <div class="w3-cell-row w3-margin-top w3-padding">
                  <div class="w3-cell">
                      <button class="w3-button w3-block primary w3-round" @click="() => {modalConfirm = false; modal = 1}">Não</button>
                  </div>
                  <div class="w3-cell">
                      <button class="w3-button w3-block secondary text-primary w3-round" @click="remover">Sim</button>
                  </div>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
    import PesquisarProduto from "./PesquisarProduto"
    import {Money} from 'v-money'

    export default {
      name: "Pedido",
      components: {PesquisarProduto, Money},
      data() {
        return {
          modal: false,
          modalConfirm: false,
          token: localStorage.getItem('key'),
          pedidos: [],
          remocoes: [],
          adicionais: [],
          desconto: 0,

          dados: {
            produto: [],
            divisoes: [],
            adicionais: [],
            remocoes: []
          },

          valorProduto: 0,

          money: {
            decimal: '.',
            thousands: '',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false
          },
            kilo: {
                decimal: '.',
                thousands: '',
                prefix: 'KG ',
                suffix: '',
                precision: 3,
                masked: false
            }
        }
      },

      methods: {
        atualizarProduto(editar) {
          this.modal = false;
          this.$emit('atualizarProduto', this.dados, editar);
        },

        editarProduto(dados) {
          this.modal = 1;
          this.dados = Object.assign({}, dados);
          let p = this.dados.produto;
          this.valorProduto = parseFloat(p.valor_total);
          this.dados.quantidade = p.quantidade ? parseFloat(p.quantidade) : dados.quantidade ? parseFloat(dados.quantidade) : 1;
        },

        remover() {
          this.modal = false;
          this.modalConfirm = false;
          this.$emit('removerProduto');
        },

        plusQtd() {
          this.dados.quantidade++;
        },

        minusQtd() {
          if (this.dados.quantidade > 1 && this.desconto > ((this.dados.quantidade - 1) * this.dados.produto.valor)) {
            openModalMsg("Atenção","Para diminuir a quantidade, remova o desconto.");
            return;
          }

          if (this.dados.quantidade > 1) {
            this.dados.quantidade--;
          }
        },

      },

      created() {
        this.$parent.$on('editarProduto', this.editarProduto);
      },

      filters: {
        fixed(value) {
          if (value !== null || value !== undefined) {
            return parseFloat(value).toFixed();
          }
        },

        medida(value) {
          if (value !== null || value !== undefined) {
            return parseFloat(value).toFixed(3) + " kg";
          }
        },

        valor(value) {
          if (value !== null || value !== undefined) {
            return parseFloat(value).toFixed(2);
          }
        }
      }

    }
</script>

<style scoped>
  .pdivisoes:after {
    content: ' / ';
    font-weight: bold;
  }

  .pdivisoes:last-child:after {
    content: '';
  }

  th {
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/admin/pdv/DetalhesProduto.vue